import { render, staticRenderFns } from "./TokensInBoxes.vue?vue&type=template&id=68c4aa42&scoped=true"
import script from "./TokensInBoxes.vue?vue&type=script&lang=js"
export * from "./TokensInBoxes.vue?vue&type=script&lang=js"
import style0 from "./TokensInBoxes.vue?vue&type=style&index=0&id=68c4aa42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c4aa42",
  null
  
)

export default component.exports